export class Signatario {
  idSignatario: number;
  idGIContato?: number;
  nome: string;
  email: string;
  cpf: string;
  tipo: number;
}
